// Merchant required to edit the message bar position
document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(function () {
    const messageBarContent = document.querySelector(
      ".scaaf-message-bar .scaaf-message-bar-content"
    );
    const stickyHeader = document.querySelector(
      "header.is-absolute div.is-absolute"
    );
    if (!messageBarContent || !stickyHeader) {
      return;
    }

    if (getComputedStyle(messageBarContent).visibility != "visible") {
      return;
    }

    const messageBar = messageBarContent.parentNode;
    clearInterval(interval);
    const clonerMessageBar = messageBar.cloneNode(2);
    stickyHeader.prepend(clonerMessageBar);
    clonerMessageBar.style.position = "relative";
    messageBar.remove();
  }, 100);

  setTimeout(() => {
    clearInterval(interval);
  }, 10e3);
});
